///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.js-scripting-buttons')) {
      document.querySelector('.process-review-form').addEventListener('click', (e) => {
        const target = e.target;

        if (scriptingElement(target)) {
          const scriptingInterface = new ScriptingInterface();

          if (target.classList.contains('js-toggle-scripting-button')) {
            scriptingInterface.toggleInterface();
          } else if (target.classList.contains('js-partially-expand-scripting-button')) {
            scriptingInterface.partiallyExpandInterface();
          } else if (target.classList.contains('js-fully-expand-scripting-button')) {
            scriptingInterface.fullyExpandInterface();
          }
        }
      });
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Constructors
  //
  ///////////////////////////////////////////////////////////////////

  function ScriptingInterface() {
    this.scriptingButtonGroup   = document.querySelector('.js-scripting-buttons');
    this.scriptingToggleButton  = document.querySelector('.js-toggle-scripting-button');
    this.scriptingPartialButton = document.querySelector('.js-partially-expand-scripting-button');
    this.scriptingFullButton    = document.querySelector('.js-fully-expand-scripting-button');

    this.scriptingColumn = document.querySelector('.js-sticky-column');
    this.scriptingField  = document.querySelector('.js-scripting-field');
    this.standardsColumn = document.querySelector('.js-standards-column');
  }



  ///////////////////////////////////////////////////////////////////
  //
  // Prototype Definitions
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Toggles scripting interface
  //
  //
  ScriptingInterface.prototype.toggleInterface = function() {
    if (sizeButtonsHidden(this)) {
      showScriptingField(this);
    } else {
      hideScriptingField(this);
    }
  };

  ///////////////////////////////////////////////
  //
  // Description - Partially expand scripting interface
  //
  ScriptingInterface.prototype.partiallyExpandInterface = function() {
    expandScriptingInterface(this, 'col-8', 'col-4');
  };

  ///////////////////////////////////////////////
  //
  // Description - Fully expand scripting interface
  //
  ScriptingInterface.prototype.fullyExpandInterface = function() {
    expandScriptingInterface(this, 'col-5', 'col-7');
  };



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Clears columns size classes. This
  //               callback is invoked before the
  //               requested columns sizes are applied
  //               in sizing-related methods.
  //
  function clearColumnSizes(scriptingInterfaceObj) {
    for (let i = scriptingInterfaceObj.standardsColumn.classList.length - 1; i >= 0; i--) {
      const className = scriptingInterfaceObj.standardsColumn.classList[i];
      if (className.startsWith('col-')) {
        scriptingInterfaceObj.standardsColumn.classList.remove(className);
      }
    }

    for (let i = scriptingInterfaceObj.scriptingColumn.classList.length - 1; i >= 0; i--) {
      const className = scriptingInterfaceObj.scriptingColumn.classList[i];
      if (className.startsWith('col-')) {
        scriptingInterfaceObj.scriptingColumn.classList.remove(className);
      }
    }
  }

  ///////////////////////////////////////////////
  //
  // Description - Expand scripting interface according
  //               to requested size and update button
  //               styling
  //
  function expandScriptingInterface(scriptingInterfaceObj, standardsColWidth, scriptingColWidth) {
    // adjust column sizes
    clearColumnSizes(scriptingInterfaceObj);
    scriptingInterfaceObj.standardsColumn.classList.add(standardsColWidth);
    scriptingInterfaceObj.scriptingColumn.classList.add(scriptingColWidth);

    // re-assign 'active' class on selected button
    styleSelectedSizingButton(scriptingColWidth, scriptingInterfaceObj);

    // auto-focus and set cursor at end of text area input
    const contentLength = scriptingInterfaceObj.scriptingField.value.length;
    scriptingInterfaceObj.scriptingField.setSelectionRange(contentLength, contentLength);
    scriptingInterfaceObj.scriptingField.focus();
  }

  ///////////////////////////////////////////////
  //
  // Description - Hide scripting interface
  //
  function hideScriptingField(scriptingInterfaceObj) {
    const pencilIcon = "<i class='fas fa-pencil-alt fa-lg'></i>";

    // adjust column sizes
    clearColumnSizes(scriptingInterfaceObj);

    scriptingInterfaceObj.standardsColumn.classList.add('col-11');
    scriptingInterfaceObj.scriptingColumn.classList.add('col-1');

    toggleSizingButtons(scriptingInterfaceObj);

    // hide scritping comment field
    scriptingInterfaceObj.scriptingField.classList.add('d-none');

    // adjust button styling
    scriptingInterfaceObj.scriptingToggleButton.innerHTML = pencilIcon;
  }

  ///////////////////////////////////////////////
  //
  // Description - Determines whether or not a scripting
  //               button is the event target
  //
  function scriptingElement(eventTarget) {
    return (eventTarget.classList.contains('js-toggle-scripting-button') ||
            eventTarget.classList.contains('js-partially-expand-scripting-button') ||
            eventTarget.classList.contains('js-fully-expand-scripting-button'));
  }

  ///////////////////////////////////////////////
  //
  // Description - Show scripting interface
  //
  function showScriptingField(scriptingInterfaceObj) {
    // adjust column sizes
    clearColumnSizes(scriptingInterfaceObj);

    toggleSizingButtons(scriptingInterfaceObj);

    // display scripting comment field
    scriptingInterfaceObj.scriptingField.classList.remove('d-none');

    // adjust button styling
    scriptingInterfaceObj.scriptingToggleButton.innerHTML = "<i class='fas fa-times fa-lg'></i>";

    scriptingInterfaceObj.partiallyExpandInterface();
  }

  ///////////////////////////////////////////////
  //
  // Description - Check if both sizing buttons are hidden
  //
  function sizeButtonsHidden(scriptingInterfaceObj) {
    return (scriptingInterfaceObj.scriptingPartialButton.classList.contains('d-none') &&
            scriptingInterfaceObj.scriptingFullButton.classList.contains('d-none'));
  }

  ///////////////////////////////////////////////
  //
  // Description - Removes/applies active class
  //               on sizing buttons
  //
  function styleSelectedSizingButton(scriptingColWidth, scriptingInterfaceObj) {
    let selectedButton;

    // determine selected button based on requested scripting column width
    if (scriptingColWidth === 'col-4') {
      selectedButton = scriptingInterfaceObj.scriptingPartialButton;
    } else if (scriptingColWidth === 'col-7') {
      selectedButton = scriptingInterfaceObj.scriptingFullButton;
    }

    // remove 'active' class from non-selected sizing button
    if (selectedButton.classList.contains('js-partially-expand-scripting-button')) {
      // remove active class from non-selected full expansion button if necessary
      if (scriptingInterfaceObj.scriptingFullButton.classList.contains('active')) {
        scriptingInterfaceObj.scriptingFullButton.classList.remove('active');
      }
    } else if (selectedButton.classList.contains('js-fully-expand-scripting-button')) {
      // remove active class from non-selected partial button if necessary
      if (scriptingInterfaceObj.scriptingPartialButton.classList.contains('active')) {
        scriptingInterfaceObj.scriptingPartialButton.classList.remove('active');
      }
    }

    // add active class to selected partial expansion button
    selectedButton.classList.add('active');
  }

  ///////////////////////////////////////////////
  //
  // Description - Toggle display of sizing buttons
  //
  function toggleSizingButtons(scriptingInterfaceObj) {
    if (sizeButtonsHidden(scriptingInterfaceObj)) {
      scriptingInterfaceObj.scriptingButtonGroup.classList.remove('justify-content-around');
      scriptingInterfaceObj.scriptingButtonGroup.classList.add('justify-content-between');

      scriptingInterfaceObj.scriptingPartialButton.classList.remove('d-none');
      scriptingInterfaceObj.scriptingFullButton.classList.remove('d-none');
    } else {
      scriptingInterfaceObj.scriptingButtonGroup.classList.remove('justify-content-between');
      scriptingInterfaceObj.scriptingButtonGroup.classList.add('justify-content-around');

      scriptingInterfaceObj.scriptingPartialButton.classList.add('d-none');
      scriptingInterfaceObj.scriptingFullButton.classList.add('d-none');
    }
  }
}());
